<template>
  <div class="login-page">
    <!-- 返回首页 -->
    <div class="back-home" @click="goBack">
      <img
        class="back-icon"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
        alt=""
      />
      <span>返回首页</span>
    </div>
    <img
      class="login-icon"
      src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-16Login1256123.png"
      alt=""
    />
    <!-- 登录标题 -->
    <h1 class="login-title">账号登录</h1>

    <!-- 登录选项卡 -->
    <div class="login-tabs">
      <div
        class="tab-item"
        :class="{ active: activeTab === 'password' }"
        @click="switchTab('password')"
      >
        密码登录
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'sms' }"
        @click="switchTab('sms')"
      >
        验证码登录
      </div>
    </div>

    <!-- 登录表单 -->
    <div class="login-form">
      <div class="form-item">
        <label class="form-label">手机号</label>
        <input
          autocomplete="new-password"
          type="text"
          class="form-input"
          placeholder="请输入手机号"
          v-model.trim="form.phone"
          @input="handlePhoneInput"
          maxlength="11"
        />
      </div>

      <!-- 密码登录表单 -->
      <template v-if="activeTab === 'password'">
        <div class="form-item">
          <label class="form-label">密码</label>
          <div class="password-input-wrapper">
            <input
              autocomplete="new-password"
              :type="showPassword ? 'text' : 'password'"
              class="form-input password-input"
              placeholder="请输入密码"
              v-model.trim="form.password"
              @keydown="$utils.handleKeydownFilter"
              maxlength="20"
            />
            <img
              v-if="showPassword"
              @click="togglePassword"
              class="password-eye"
              src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login1.png"
              alt=""
            />
            <img
              v-else
              @click="togglePassword"
              class="password-eye"
              src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login2.png"
              alt=""
            />
          </div>
        </div>
      </template>

      <!-- 验证码登录表单 -->
      <template v-if="activeTab === 'sms'">
        <div class="form-item">
          <label class="form-label">验证码</label>
          <div class="sms-input-wrapper">
            <input
              autocomplete="new-password"
              type="text"
              class="form-input sms-input"
              placeholder="请输入验证码"
              v-model.trim="form.captcha"
              @keydown="$utils.handleKeydownFilter"
              maxlength="6"
            />
            <button
              class="sms-btn"
              :disabled="countdown > 0 || !canGetCode"
              @click="handleGetCode"
            >
              {{ countdown > 0 ? `${countdown}秒` : "获取验证码" }}
            </button>
          </div>
        </div>
      </template>

      <div class="form-item agree-item">
        <!-- 优化后的复选框逻辑：点击时切换选中状态，并清除对应的错误提示 -->
        <img
          v-if="form.agree"
          @click="toggleAgreement"
          class="checkbox"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login4.png"
          alt="已同意协议"
        />
        <img
          v-else
          @click="toggleAgreement"
          class="checkbox"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login5.png"
          alt="未同意协议"
        />
        <span class="agree-text">
          我已认真阅读并接受
          <a href="javascript:;" @click="goPolicy('privacy')"
            >《WONZ 隐私政策》</a
          >、
          <a href="javascript:;" @click="goPolicy('service')"
            >《WONZ服务协议》</a
          >。
        </span>
      </div>
      <button class="login-btn" :disabled="!canLogin" @click="handleLogin">
        登录
      </button>

      <div class="form-links">
        <span class="link-item" @click="goRegister">快速注册</span>
        <span class="divider">|</span>
        <span class="link-item" @click="goForgetPwd">忘记密码</span>
      </div>
    </div>
    <!-- 页脚 -->
    <FooterModel class="po"></FooterModel>
    <!--  -->
    <GoLoginPop ref="GoLoginPop"></GoLoginPop>
  </div>
</template>

<script>
import { getCode, login_password, login_code, checkPhone } from "@/api/index";
import GoLoginPop from "@/components/GoLoginPop.vue";
import FooterModel from "@/components/FooterModel.vue";
export default {
  name: "Login",
  components: {
    FooterModel,
    GoLoginPop,
  },
  data() {
    return {
      activeTab: "password", // 'password' | 'sms'
      form: {
        phone: "",
        password: "",
        captcha: "",
        agree: false,
      },
      showPassword: false,
      countdown: 0,
      countdownTimer: null,
      errors: {
        phone: "",
        password: "",
        captcha: "",
        agree: "",
      },
    };
  },
  computed: {
    // 手机号正则
    phoneReg() {
      return /^1[3-9]\d{9}$/;
    },
    // 密码长度校验
    passwordValid() {
      return this.form.password.length >= 6 && this.form.password.length <= 20;
    },
    // 是否可以获取验证码
    canGetCode() {
      if (!this.form.phone || this.form.phone.length !== 11) return false;
      // if (!this.phoneReg.test(this.form.phone)) return false;
      // if (!this.form.agree) return false;
      return true;
    },
    // 是否可以点击登录
    canLogin() {
      // if (!this.form.agree) return false;
      if (this.form.phone.length !== 11) return false;
      // if (!this.phoneReg.test(this.form.phone)) return false;

      if (this.activeTab === "password") {
        return !!this.form.password && this.passwordValid;
      } else {
        return !!this.form.captcha;
      }
    },
  },
  mounted() {
    // this.$refs.GoLoginPop.open(1)
  },
  watch: {
    // 监听表单变化，清除对应错误
    "form.phone"(val) {
      if (val) this.clearError("phone");
    },
    "form.password"(val) {
      if (val) this.clearError("password");
    },
    "form.captcha"(val) {
      if (val) this.clearError("captcha");
    },
  },
  methods: {
    goBack() {
      this.$router.replace("/");
    },
    // 切换登录方式
    switchTab(tab) {
      this.activeTab = tab;
      this.clearAllErrors();
    },
    toggleAgreement() {
      // 切换选中状态
      this.form.agree = !this.form.agree;
      // 清除协议勾选的错误提示
      this.clearError("agree");
    },
    // 手机号输入限制（仅数字）
    handlePhoneInput(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, "");
      this.form.phone = e.target.value;
    },
    // 切换密码可见性
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    // 清除单个错误
    clearError(field) {
      this.errors[field] = "";
    },
    // 清除所有错误
    clearAllErrors() {
      Object.keys(this.errors).forEach((key) => {
        this.errors[key] = "";
      });
    },
    // 前端校验（密码登录）
    validatePasswordLogin() {
      this.clearAllErrors();
      let isValid = true;

      if (!this.form.phone) {
        this.$toast.error("请输入手机号");
        return (isValid = false);
      } else if (!this.phoneReg.test(this.form.phone)) {
        this.$toast.error("请输入正确手机号");
        return (isValid = false);
      }

      if (!this.form.password) {
        this.$toast.error("请输入密码");
        return (isValid = false);
      } else if (!this.passwordValid) {
        this.$toast.error("密码长度需为6-20位");
        return (isValid = false);
      }

      if (!this.form.agree) {
        this.$toast.info("请先阅读并同意隐私政策及服务协议");
        return (isValid = false);
      }

      return isValid;
    },
    // 前端校验（验证码登录）
    validateSmsLogin() {
      this.clearAllErrors();
      let isValid = true;

      if (!this.form.phone) {
        this.$toast.error("请输入手机号");
        return (isValid = false);
      } else if (!this.phoneReg.test(this.form.phone)) {
        this.$toast.error("请输入正确手机号");
        return (isValid = false);
      }

      if (!this.form.captcha) {
        this.$toast.error("请输入验证码");
        return (isValid = false);
      }

      if (!this.form.agree) {
        this.$toast.info("请先阅读并同意隐私政策及服务协议");
        return (isValid = false);
      }

      return isValid;
    },
    // 获取验证码
    async handleGetCode() {
      this.clearAllErrors();
      if (!this.form.phone) {
        this.$toast.error("请输入手机号");
        return;
      }
      if (!this.phoneReg.test(this.form.phone)) {
        this.$toast.error("请输入正确手机号");
        return;
      }
      if (!this.form.agree) {
        this.$toast.info("请先阅读并同意隐私政策及服务协议");
        return;
      }

      try {
        let exist = true;
        await checkPhone({
          phone: this.form.phone,
        }).then((res) => {
          exist = res.exist;
        });
        if (!exist) {
          this.$refs.GoLoginPop.open(1);
          return;
        }
        const res = await getCode({
          // areaCode: "0086",
          phone: this.form.phone,
          sendType: "login",
        });
        console.log("获取验证码请求成功");

        // 3. 开始倒计时
        this.countdown = 60;
        this.countdownTimer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.countdownTimer);
          }
        }, 1000);
      } catch (err) {
        console.error("获取验证码失败", err);
        this.$toast.error(err.msg);
      }
    },
    // 登录提交
    async handleLogin() {
      let isValid = false;

      if (this.activeTab === "password") {
        isValid = this.validatePasswordLogin();
      } else {
        isValid = this.validateSmsLogin();
      }

      if (!isValid) return;

      // 前端校验通过，提交后端
      try {
        let res;
        if (this.activeTab === "password") {
          // 密码登录接口
          await login_password({
            phone: this.form.phone,
            password: this.form.password,
          }).then((res) => {
            localStorage.setItem("phone", JSON.stringify(this.form.phone));
            localStorage.setItem("token", JSON.stringify(res.token));
          });
        } else {
          // 验证码登录接口
          await login_code({
            phone: this.form.phone,
            captcha: this.form.captcha,
          }).then((res) => {
            localStorage.setItem("phone", JSON.stringify(this.form.phone));
            localStorage.setItem("token", JSON.stringify(res.token));
          });
          console.log("验证码登录提交");
        }

        // 登录成功
        this.$toast.success("登录成功");
        this.goBack();
      } catch (err) {
        console.error("登录失败", err);
        // 统一错误提示
        if (err.msg.indexOf("未注册") > -1) {
          this.$refs.GoLoginPop.open(1);
        } else {
          this.$toast.error(err.msg);
        }
      }
    },
    // 跳转协议页面
    goPolicy(type) {
      if (type === "privacy") {
        this.$router.replace("/PrivacyPolicy");
      } else {
        this.$router.replace("/UserAgreement");
      }
    },
    goRegister() {
      this.$router.replace("/Register");
    },
    goForgetPwd() {
      this.$router.replace("/ResetPass");
    },
  },
  beforeDestroy() {
    // 清除定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .po {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .login-page {
    height: 100vh;
    width: 100%;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // padding: 3.75rem 1.25rem;
    padding-top: 3.75rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;

    .back-home {
      width: 38rem;
      margin: auto;
      margin-bottom: 2.625rem;
      display: flex;
      align-items: center;
      color: #333;
      font-weight: 500;
      font-size: 1.25rem;
      color: #4e5361;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 1.625rem;
        height: 1.625rem;
        margin-right: 1.1rem;
      }
    }
    .login-icon {
      display: none;
    }
    .login-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-bottom: 2rem;
    }

    .login-tabs {
      display: flex;
      width: 38rem;
      border-bottom: 1px solid #e5e7eb;
      margin: auto;
      margin-bottom: 2rem;

      .tab-item {
        flex: 1;
        text-align: center;
        padding: 1.1rem 0;
        font-size: 1.5rem;
        color: #9fa1a8;
        cursor: pointer;
        position: relative;

        &.active {
          color: #1677ff;
          font-weight: 500;

          &::after {
            content: "";
            position: absolute;
            bottom: -0.125rem;
            left: 0;
            width: 100%;
            height: 0.25rem;
            background-color: #1677ff;
          }
        }
      }
    }

    .login-form {
      width: 38rem;
      padding: 3.1875rem;
      margin: auto;
      background: #fff;
      border-radius: 1.4rem;
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid #0074fc33;

      .form-item {
        width: 31.625rem;
        margin: auto;
        margin-bottom: 1.25rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        &.agree-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 2.1875rem;
          margin-top: 2.1875rem;
        }

        .form-label {
          font-size: 0.875rem;
          color: #333;
          font-weight: 500;
        }

        .form-input {
          width: 31.625rem;
          height: 3.875rem;
          background: #ffffff;
          border-radius: 0.75rem;
          border: 1px solid #e5e5e7;
          font-weight: 400;
          font-size: 1.125rem;
          color: #101424ff;
          text-align: left;

          padding: 0 0.75rem;
          outline: none;
          transition: border-color 0.2s;

          &:focus {
            border-color: #0074fc;
            color: #101424ff;
          }

          &::placeholder {
            color: #e5e5e7;
          }
        }

        .password-input-wrapper {
          position: relative;

          .password-input {
            padding-right: 2.75rem;
          }

          .password-eye {
            position: absolute;
            right: 0.75rem;
            top: 50%;
            transform: translateY(-50%);
            width: 1.5rem;
            height: 1.5rem;
            cursor: pointer;
            user-select: none;
          }
        }

        .sms-input-wrapper {
          display: flex;
          gap: 0.75rem;

          .sms-input {
            flex: 1;
          }

          .sms-btn {
            width: 8.125rem;
            height: 3.875rem;
            background-color: #1677ff;
            color: #fff;
            border: none;
            border-radius: 0.5rem;
            font-size: 1.125rem;
            cursor: pointer;
            transition: background-color 0.2s;

            &:disabled {
              background-color: #c4c6cc;
              cursor: not-allowed;
            }

            &:not(:disabled):hover {
              background-color: #4096ff;
            }
          }
        }
        .checkbox {
          cursor: pointer;
          height: 0;
          width: 0.9375rem;
          height: 0.9375rem;
          cursor: pointer;
          user-select: none;
        }

        .agree-text {
          flex: 1;
          font-size: 0.9375rem;
          color: #666;
          line-height: 1.4;

          a {
            color: #0074fcff;
            text-decoration: none;
          }
        }

        .error-tip {
          font-size: 0.75rem;
          color: #ff4d4f;
          line-height: 1.2;
          margin: 0;
        }
      }

      .login-btn {
        width: 31.625rem;
        height: 3.875rem;
        background: #0074fc;
        border-radius: 0.75rem;
        font-weight: 500;
        font-size: 1.5rem;
        color: #ffffff;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
        transition: background-color 0.2s;

        &:disabled {
          background-color: #c4c6cc;
          cursor: not-allowed;
        }

        &:not(:disabled):hover {
          background-color: #0074fc;
        }
      }

      .form-links {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        margin-top: 1.25rem;
        font-size: 0.875rem;

        .link-item {
          color: #1677ff;
          cursor: pointer;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        .divider {
          color: #1677ff;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .login-page {
    height: 100vh;
    width: 100%;
    background: #fff;
    overflow-y: scroll;
    // padding-bottom: 16rem;
    // background: linear-gradient( 73deg, #E8F2FF 0%, #FFFFFF 50%, #F4F1FF 100%);

    padding-top: 4rem;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;

    .back-home {
      width: 42.375rem;
      margin: auto;
      margin-bottom: 4rem;
      display: flex;
      position: relative;
      align-items: center;
      color: #333;
      font-weight: 600;
      font-size: 1.75rem;
      color: #4e5361;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 2.25rem;
        height: 2.25rem;
        margin-right: 1.1rem;
      }
    }

    .login-icon {
      width: 15rem;
      height: 4.25rem;
      display: block;
      margin: auto;
      margin-bottom: 1.4rem;
    }
    .login-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-bottom: 3rem;
    }

    .login-tabs {
      display: flex;
      width: 42.375rem;
      border-bottom: 0.25rem solid #e5e7eb;
      margin: auto;
      margin-bottom: 2rem;

      .tab-item {
        flex: 1;
        font-weight: bold;
        text-align: center;
        padding: 1.1rem 0;
        font-size: 2rem;
        color: #9fa1a8;
        cursor: pointer;
        position: relative;

        &.active {
          color: #0074fc;
          font-weight: 500;

          &::after {
            content: "";
            position: absolute;
            bottom: -0.35rem;
            left: 0;
            width: 100%;
            height: 0.5rem;
            background-color: #1677ff;
            border-radius: 0.7rem;
          }
        }
      }
    }

    .login-form {
      width: 42.375rem;
      padding: 3rem 0rem;
      margin: auto;
      margin-bottom: 12rem;
      background: #fff;
      border-radius: 1.5rem;
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid #0074fc33;

      .form-item {
        width: 37.875rem;
        margin: auto;
        margin-bottom: 1.25rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        &.agree-item {
          display: flex;
          flex-direction: row;
          align-items: top;
          gap: 0.5rem;
          margin-bottom: 2.1875rem;
          margin-top: 2.1875rem;
        }

        .form-label {
          font-size: 2rem;
          color: #333;
          font-weight: 500;
        }

        .form-input {
          width: 37.875rem;
          height: 6.5rem;
          background: #ffffff;
          border-radius: 1.5rem;
          border: 1px solid #e5e5e7;
          font-weight: 400;
          font-size: 1.75rem;
          color: #101424ff;
          text-align: left;

          padding: 0 2rem;
          outline: none;
          transition: border-color 0.2s;

          &:focus {
            border-color: #0074fc;
            color: #101424ff;
          }

          &::placeholder {
            color: #e5e5e7;
          }
        }

        .password-input-wrapper {
          position: relative;

          .password-input {
            padding-right: 2.75rem;
          }

          .password-eye {
            position: absolute;
            right: 2rem;
            top: 50%;
            transform: translateY(-50%);
            width: 3rem;
            height: 3rem;
            cursor: pointer;
            user-select: none;
          }
        }

        .sms-input-wrapper {
          display: flex;
          gap: 0.75rem;

          .sms-input {
            flex: 1;
          }

          .sms-btn {
            width: 12.5rem;
            height: 6.5rem;
            background-color: #1677ff;
            color: #fff;
            border: none;
            border-radius: 1.5rem;
            font-size: 1.75rem;
            cursor: pointer;
            transition: background-color 0.2s;

            &:disabled {
              background-color: #c4c6cc;
              cursor: not-allowed;
            }

            &:not(:disabled):hover {
              background-color: #4096ff;
            }
          }
        }
        .checkbox {
          cursor: pointer;
          height: 0;
          width: 1.5rem;
          height: 1.5rem;
          cursor: pointer;
          user-select: none;
          margin-top: 0.2rem;
        }

        .agree-text {
          flex: 1;
          font-size: 1.5rem;
          color: #666;
          line-height: 1.4;

          a {
            color: #0074fcff;
            text-decoration: none;
          }
        }

        .error-tip {
          font-size: 0.75rem;
          color: #ff4d4f;
          line-height: 1.2;
          margin: 0;
        }
      }

      .login-btn {
        width: 37.875rem;
        height: 6.5rem;
        margin: auto;
        display: block;
        background: #0074fc;
        font-weight: 500;
        font-size: 2.25rem;
        color: #ffffff;
        text-align: center;
        font-style: normal;
        text-transform: none;
        border-radius: 1.5rem;
        cursor: pointer;
        transition: background-color 0.2s;

        &:disabled {
          background-color: #c4c6cc;
          cursor: not-allowed;
        }

        &:not(:disabled):hover {
          background-color: #0074fc;
        }
      }

      .form-links {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        margin-top: 2rem;
        font-size: 1.5rem;

        .link-item {
          color: #1677ff;
          cursor: pointer;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }

        .divider {
          color: #1677ff;
        }
      }
    }
  }
}
</style>